"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createDateTimeFormatterInternal = void 0;
var _model = require("../model");
var _misc = require("../misc");
var formatFullOffset = function formatFullOffset(locale, formatter, timeZoneFormatter, date) {
  var parts = formatter.formatToParts(date);
  var timeZoneOffset = timeZoneFormatter.formatToParts(date).find(function (part) {
    return part.type === 'timeZoneName';
  });
  var formattedTimeZone = parts.find(function (part) {
    return part.type === 'timeZoneName';
  });
  if (formattedTimeZone === undefined || timeZoneOffset === undefined) {
    return formatter.format(date);
  }
  if ((0, _misc.isRTL)(locale)) {
    formattedTimeZone.value += "\u202A(".concat(timeZoneOffset.value, ") \u202C");
  } else {
    formattedTimeZone.value += " (".concat(timeZoneOffset.value, ")");
  }
  return parts.map(function (p) {
    return p.value;
  }).join('');
};
var createStyledDateTimeFormatter = function createStyledDateTimeFormatter(locale, constructor, timeZone, timeZoneFormatter, dateStyle, timeStyle) {
  var actualDateStyle = dateStyle;
  if (dateStyle === undefined && timeStyle === undefined) {
    actualDateStyle = _model.DateStyle.Short;
  }
  var options;
  if (actualDateStyle === _model.DateStyle.NoYear) {
    options = {
      day: 'numeric',
      month: 'numeric',
      timeZone: timeZone
    };
  } else if (timeStyle === _model.TimeStyle.FullOffset) {
    options = {
      dateStyle: actualDateStyle,
      timeStyle: _model.TimeStyle.Full,
      timeZone: timeZone
    };
  } else {
    options = {
      dateStyle: actualDateStyle,
      timeStyle: timeStyle,
      timeZone: timeZone
    };
  }
  var formatter = constructor(options);
  if (timeStyle === _model.TimeStyle.FullOffset) {
    return function (date) {
      return formatFullOffset(locale, formatter, timeZoneFormatter, date);
    };
  }
  return function (date) {
    return formatter.format(date);
  };
};
var DefaultConstructor = function DefaultConstructor(options) {
  return new Intl.DateTimeFormat('en-US', options);
};
var createDateTimeFormatterInternal = exports.createDateTimeFormatterInternal = function createDateTimeFormatterInternal(locale) {
  var constructor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DefaultConstructor;
  var timezone = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'America/Denver';
  try {
    var formatters = new Map();
    var timezoneFormatter = Intl.DateTimeFormat('fr', {
      timeZoneName: 'longOffset',
      timeZone: timezone
    });
    return function (date, dateStyle, timeStyle) {
      try {
        var key = "".concat(dateStyle, "#").concat(timeStyle);
        var formatter = formatters.get(key);
        if (formatter === undefined) {
          formatter = createStyledDateTimeFormatter(locale, constructor, timezone, timezoneFormatter, dateStyle, timeStyle);
          formatters.set(key, formatter);
        }
        return formatter(date);
      } catch (e) {
        return new Date(date).toDateString();
      }
    };
  } catch (e) {
    return function (date) {
      return new Date(date).toDateString();
    };
  }
};
//# sourceMappingURL=dateTimeFormatInternal.js.map